import '../css/app.css';
import './bootstrap';

import { createInertiaApp, router } from '@inertiajs/vue3';
import type { Page } from '@inertiajs/core';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, DefineComponent, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import AppLayout from '@/Layouts/AppLayout.vue'
import { capitalize } from '@/Composables/capitalize'
import {createPinia} from 'pinia';

import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import Notifications from '@kyvg/vue3-notification';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura'
import { definePreset } from '@primevue/themes'

const appName = capitalize(window.document.getElementsByTagName('title')[0]?.innerText) ||import.meta.env.VITE_APP_NAME || 'Dita Kurnia';

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{sky.50}',
            100: '{sky.100}',
            200: '{sky.200}',
            300: '{sky.300}',
            400: '{sky.400}',
            500: '{sky.500}',
            600: '{sky.600}',
            700: '{sky.700}',
            800: '{sky.800}',
            900: '{sky.900}',
            950: '{sky.950}'
        }
    }
});

const trackComponent = (page: Page): void => {
    window.component = {
        php: (page.props?.component_php as string) || null,
        vue: page.component ? `resources/js/Pages/${page.component}.vue` : null,
    }
}

router.on('navigate', (event) => trackComponent(event.detail.page))

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>{
        const pages = import.meta.glob('./Pages/**/*.vue', { eager: true })
        let page = pages[`./Pages/${name}.vue`]
        if(!page) console.error(`File './Pages/${name}.vue' is not exist`)
        page.default.layout = page.default.layout || AppLayout
        return page
    },
    setup({ el, App, props, plugin }) {
        trackComponent(props.initialPage)

        createApp({ render: () => h(App, props) })
            .use(createPinia())
            .use(plugin)
            .use(FloatingVue)
            .use(PrimeVue, {
                theme: {
                    preset: MyPreset,
                    options: {
                        darkModeSelector: '.my-app-dark',
                    }
                },
                locale: {
                    dayNames: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
                    dayNamesShort: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
                    dayNamesMin: ['Mi', 'Se', 'Se', 'Ra', 'Ka', 'Ju', 'Sa'],
                    monthNames: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
                    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sep', 'Okt', 'Nov', 'Des'],
                    today: 'Hari Ini',
                    clear: 'Hapus',
                }
            })
            .use(Notifications)
            .use(ZiggyVue)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
